module.exports = __webpack_public_path__ + "img/b-1.aaf35b38.png";